import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import { SAVE_OBJECTIVE_KEY_RESULT } from "./graphql";
import KeyResultForm from "./KeyResultForm";

const KeyResultView = ({ keyResult }) => {
  const modal = useModals();
  const [updateStatus, { loading }] = useMutation(SAVE_OBJECTIVE_KEY_RESULT, {
    onCompleted() {
      Alert("success", "Status updated.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function editHandler() {
    modal.present({
      title: "Edit Key Result",
      center: true,
      children: (
        <KeyResultForm originalKeyResult={keyResult} hide={modal.hide} />
      ),
    });
  }

  return (
    <div className="border-t py-2 border-gray-100 dark:border-gray-700">
      <div className="flex justify-between items-center space-x-4">
        <div className="text-sm flex items-center space-x-1">
          <Button onClick={editHandler} className="whitespace-normal shrink">
            [Q{keyResult.dueQuarter}] {keyResult.description}
          </Button>
          <span className="opacity-70 pl-1 whitespace-nowrap">
            {Array(keyResult.weight).fill("🐠").join(" ")}
          </span>
        </div>
        <Select
          className={`text-xs ${
            keyResult.status === "COMPLETED"
              ? "bg-green-100 border-green-200"
              : ""
          }`}
          value={keyResult.status}
          loading={loading}
          onChange={(e) =>
            updateStatus({
              variables: { id: keyResult.id, status: e.target.value },
            })
          }
        >
          <option value="DELAYED">🔴 Delayed</option>
          <option value="AT_RISK">🟡 At Risk</option>
          <option value="ON_TRACK">🔵 On Track</option>
          <option value="COMPLETED">🟢 Completed</option>
        </Select>
      </div>

      {keyResult.notes && (
        <div className="mt-1 whitespace-pre-wrap italic">
          Notes: {keyResult.notes}
        </div>
      )}
    </div>
  );
};

export default KeyResultView;
